import { render, staticRenderFns } from "./FilterTabs.vue?vue&type=template&id=da67d0ac"
import script from "./FilterTabs.vue?vue&type=script&lang=js"
export * from "./FilterTabs.vue?vue&type=script&lang=js"
import style0 from "./FilterTabs.vue?vue&type=style&index=0&id=da67d0ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports